import * as React from 'react';
import Icon from '@ant-design/icons/lib/components/Icon';
const Abbreviation = React.memo((props) => (<Icon component={() => (<svg focusable="false" width="24px" height="24px" fill="currentColor" viewBox="0 0 24 24">
        <path d="M6 11a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm6 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm6 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
      </svg>)} {...props}/>));
export default Abbreviation;
